(function () {
  const $productComplementaryItems = document.querySelectorAll(
    ".js-product-complementary-add-to-cart"
  );

  if ($productComplementaryItems === null) {
    return;
  }

  $productComplementaryItems.forEach(($item) => {
    $item.addEventListener("click", (evt) => {
      evt.preventDefault();

      const variantId = evt.target.dataset.id;
      let formData = {
        items: [
          {
            id: variantId,
            quantity: 1,
          },
        ],
      };

      fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      })
        .then((response) => {
          return response.json();
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    });
  });
})();
